export default __webpack_public_path__ + "static/media/studentRealCase1-mobile-sc.f48cfac2.jpg";